import React from 'react'
import thanks from "../../../Assets/images/thanks.jpg"
function Thanks({ order }) {
    return (
        <>
            <section className="aon-howit-area2 no-order-container  mt-3 pb-0">
                <div className="container ">
                    <div className="aon-howit-area2-section pb-2">
                        <div className="aon-howit-area2-bg">
                            {/*Title Section Start*/}
                            <div className="section-head aon-title-center white">
                                <span className="aon-sub-title">
                                    Your order is received !!
                                </span>
                                <h2 className="sf-title text-warning">
                                    Your order is {order?.order_no}
                                </h2>
                            </div>
                            {/*Title Section Start End*/}
                            <div className="section-content">
                                <div className="aon-categories-area2-section">
                                    <div className="row justify-content-center">
                                        {/* Block 1*/}
                                        <div className="col-lg-9 col-md-6 text-center ">
                                            <div className="aon-why-choose2-line">
                                                <div className="aon-thanks-pic" >
                                                    <img
                                                        src={thanks}
                                                        alt=""
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                        {/* <div className="col-lg-4 col-md-6">
                                            <div className="aon-howit-area2-iconbox aon-icon-effect">

                                                 <div className="aon-howit-area2-content">
                                                    <h4 className="aon-tilte">
                                                        Find your Best company
                                                    </h4>
                                                    <p>
                                                        See company profiles
                                                        and then order.
                                                    </p>
                                                </div> 
                                            </div>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Thanks    